import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import * as fromLanding from '../../store/actions/landing.actions';
import * as landingSelectors from '../../store/selectors/landing.selectors';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Opinion } from '../../../shared/interfaces/opinion';

@Component({
  selector: 'app-landing-opinions',
  templateUrl: './landing-opinions.component.html',
  styleUrls: ['./landing-opinions.component.scss'],
})
export class LandingOpinionsComponent implements OnInit {
  opinions: Opinion[] = [
    {
      id: 1,
      client_name: 'María González',
      message:
        'Excelente servicio, el agua tiene un sabor increíble y la instalación fue muy rápida.',
      stars: 5,
      date: new Date('2024-11-15'),
    },
    {
      id: 2,
      client_name: 'Carlos Rodríguez',
      message:
        'Muy contento con el dispenser, el agua fría y caliente funciona perfecto.',
      stars: 5,
      date: new Date('2024-12-20'),
    },
    {
      id: 3,
      client_name: 'Laura Martínez',
      message:
        'La mejor decisión para mi hogar, agua purificada siempre disponible.',
      stars: 5,
      date: new Date('2025-01-10'),
    },
    {
      id: 4,
      client_name: 'Juan Pérez',
      message:
        'Servicio impecable y atención al cliente de primera. Lo recomiendo totalmente.',
      stars: 5,
      date: new Date('2025-02-05'),
    },
    {
      id: 5,
      client_name: 'Ana Fernández',
      message:
        'El equipo llegó en tiempo y forma. El agua ahora sabe mucho mejor, sin cloro.',
      stars: 5,
      date: new Date('2025-03-18'),
    },
    {
      id: 6,
      client_name: 'Roberto Silva',
      message:
        'Muy buen producto, funciona perfecto. La atención al cliente es excelente.',
      stars: 4,
      date: new Date('2025-04-22'),
    },
    {
      id: 7,
      client_name: 'Patricia Morales',
      message:
        'Estoy encantada con el servicio. El dispenser es elegante y funcional.',
      stars: 5,
      date: new Date('2025-05-30'),
    },
    {
      id: 8,
      client_name: 'Diego Sánchez',
      message:
        'Buena calidad de agua. El técnico fue muy profesional en la instalación.',
      stars: 4,
      date: new Date('2025-07-12'),
    },
    {
      id: 9,
      client_name: 'Lucía Torres',
      message:
        'Excelente relación calidad-precio. El agua está deliciosa y siempre fría o caliente según necesite.',
      stars: 5,
      date: new Date('2025-09-08'),
    },
    {
      id: 10,
      client_name: 'Martín López',
      message:
        'Muy satisfecho con la compra. El dispenser funciona de maravilla y el servicio postventa es muy bueno.',
      stars: 4,
      date: new Date('2025-10-25'),
    },
  ];
  destroy$: Subject<any>;
  constructor(private store: Store<AppState>) {
    this.destroy$ = new Subject<any>();
  }

  ngOnInit(): void {
    // Intentar cargar desde store
    this.store.dispatch(fromLanding.getOpinions());
    this.store
      .select(landingSelectors.selectLandingState)
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        if (state.opinions && state.opinions.length > 0) {
          this.opinions = state.opinions;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
